export const bodyFontFamily = 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
export const headingFontFamily = 'Poppins, Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';
